import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Loading } from 'tdesign-react';
import CountUp from 'react-countup';
import { fetchOverview } from '@/slices/bookkeeperSlice';
import ShadowCard from '@/components/ShadowCard';
import { getChartsData } from '@/services/bookkeeperService';
import { isVoid } from '@/utils/common';
import BoardPanel from '@/components/Cluster/BoardPanel';
import ConfigDiff from '@/components/Cluster/ConfigDiff';
import SummaryBlock from '@/components/Cluster/SummaryBlock';
import HealthGaugeBlock from '../../components/HealthGaugeBlock';

function Dashboard({ fetchOverview, overview, loading }) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');
  useEffect(() => {
    if (clusterName) {
      fetchOverview(clusterName);
    }
  }, [clusterName, fetchOverview]);

  if (!clusterName) return null;

  return (
    <Loading loading={loading}>
      <Root>
        <Summary>
          <HealthGaugeBlock mode='Bookie' />
          <SummaryBlock
            title='Bookies'
            theme='blue'
            info={
              <>
                <CountUp end={overview.activeBookieCount || 0} duration={0.4} />/
                <CountUp end={overview.totalBookieCount || 0} duration={0.4} />
              </>
            }
            unit={overview.bkVersion}
            items={[
              {
                label: '读写',
                value: overview.readWriteBookieCount,
              },
              {
                label: '只读',
                value: overview.readOnlyBookieCount,
              },
            ]}
          />
          <SummaryBlock
            title='Ledgers'
            theme='green'
            info={<CountUp end={overview.totalLedgerCount || 0} duration={0.4} />}
          />
          <SummaryBlock
            title='待复制Ledgers'
            theme='yellow'
            info={<CountUp end={overview.totalUnderReplicateCount || 0} duration={0.4} />}
          />
          <SummaryBlock
            title='磁盘占比'
            theme='blue'
            info={
              isVoid(overview.averageDiskUsage) ? (
                '-'
              ) : (
                <CountUp end={overview.averageDiskUsage} duration={0.4} decimals={2} />
              )
            }
            unit='%'
          />
          <ConfigDiff
            theme='green'
            title='Similar Config'
            correct={overview.similarConfig}
            data={overview.similarConfigVOList || []}
          />
        </Summary>
        <BoardPanel
          style={{ flex: 1, width: 0, marginTop: -14 }}
          getChartsData={async (params) => await getChartsData({ clusterName, ...params })}
        />
      </Root>
    </Loading>
  );
}

export default connect(
  (state) => ({
    overview: state.bookkeeper.overview,
    loading: state.bookkeeper.loading,
  }),
  {
    fetchOverview,
  },
)(Dashboard);

const Root = styled.div`
  display: flex;
  align-items: flex-start;
  padding-right: 20px;
`;

const Summary = styled(ShadowCard)`
  width: 260px;
  margin-right: 16px;
`;
